import { FC } from "react"
import { DonatePage } from "../../../components/LandingPage/DonatePage"

export const LandingDonatePage: FC = () => {
  return <DonatePage />
}
